import * as React from 'react';

import './SectionCardContentStyle.less';

export interface ISectionCardContentProps {
  headerText?: string;
}

export default class SectionCardContent extends React.PureComponent<ISectionCardContentProps> {
  public render() {
    const { children, headerText } = this.props;

    return (
      <div className="section-card-content">
        {headerText ? <div className="section-card-content-header">{headerText}</div> : null}
        {children}
      </div>
    );
  }
}
